/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesVersusCostReportsByDayRollup
 */
export interface SalesVersusCostReportsByDayRollup {
    /**
     * 
     * @type {number}
     * @memberof SalesVersusCostReportsByDayRollup
     */
    icrTouchNetSales: number;
    /**
     * 
     * @type {number}
     * @memberof SalesVersusCostReportsByDayRollup
     */
    shiftCostsScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof SalesVersusCostReportsByDayRollup
     */
    timesheetCostsWorked: number;
    /**
     * 
     * @type {number}
     * @memberof SalesVersusCostReportsByDayRollup
     */
    leaveRequestCostsWorked: number;
}

/**
 * Check if a given object implements the SalesVersusCostReportsByDayRollup interface.
 */
export function instanceOfSalesVersusCostReportsByDayRollup(value: object): value is SalesVersusCostReportsByDayRollup {
    if (!('icrTouchNetSales' in value) || value['icrTouchNetSales'] === undefined) return false;
    if (!('shiftCostsScheduled' in value) || value['shiftCostsScheduled'] === undefined) return false;
    if (!('timesheetCostsWorked' in value) || value['timesheetCostsWorked'] === undefined) return false;
    if (!('leaveRequestCostsWorked' in value) || value['leaveRequestCostsWorked'] === undefined) return false;
    return true;
}

export function SalesVersusCostReportsByDayRollupFromJSON(json: any): SalesVersusCostReportsByDayRollup {
    return SalesVersusCostReportsByDayRollupFromJSONTyped(json, false);
}

export function SalesVersusCostReportsByDayRollupFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesVersusCostReportsByDayRollup {
    if (json == null) {
        return json;
    }
    return {
        
        'icrTouchNetSales': json['icrTouchNetSales'],
        'shiftCostsScheduled': json['shiftCostsScheduled'],
        'timesheetCostsWorked': json['timesheetCostsWorked'],
        'leaveRequestCostsWorked': json['leaveRequestCostsWorked'],
    };
}

  export function SalesVersusCostReportsByDayRollupToJSON(json: any): SalesVersusCostReportsByDayRollup {
      return SalesVersusCostReportsByDayRollupToJSONTyped(json, false);
  }

  export function SalesVersusCostReportsByDayRollupToJSONTyped(value?: SalesVersusCostReportsByDayRollup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'icrTouchNetSales': value['icrTouchNetSales'],
        'shiftCostsScheduled': value['shiftCostsScheduled'],
        'timesheetCostsWorked': value['timesheetCostsWorked'],
        'leaveRequestCostsWorked': value['leaveRequestCostsWorked'],
    };
}

